import React from 'react';

const Home = () => {
    return <div>Welcome to VMS</div>;
};

export default Home;
